import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
      padding: theme.spacing(2),
      [theme.breakpoints.down(767)]: { flexWrap: 'wrap-reverse' }
    },
    divider: {
      height: '350px',
      marginTop: '-16px',
      [theme.breakpoints.down(767)]: {
        height: '1px'
      }
    },
    leftPanel: {
      width: '20%',
      minWidth: '250px',
      [theme.breakpoints.down(767)]: {
        width: '100%',
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(2)
      }
    },
    rightPanel: {
      width: '80%',
      flexBasis: '100%',
      marginLeft: theme.spacing(2)
    },
    headerContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
      [theme.breakpoints.down(767)]: { flexWrap: 'wrap-reverse' }
    },
    dialogActionsRoot: {
      margin: '14px'
    },
    dataTable: {
      marginTop: theme.spacing(2),
      MUIDataTableHeadCell: {
        justifyContent: 'space-between'
      }
      // MUIDataTableBodyCell: {
      //   root: {
      //     padding: '0 !important'
      //   }
      // }
    },
    threeColumnsLayout: {
      display: 'flex',
      alignItems: 'stretch',
      height: '100%',
      flexWrap: 'wrap-reverse'
    },
    leftColumn: {
      borderRight: '1px solid #e0e0e0',
      flexGrow: 1,
      padding: theme.spacing(2)
    },
    centerColumn: {
      flexGrow: 4,
      padding: theme.spacing(2)
    },
    rightColumn: {
      flexGrow: 1
    },
    resume: {
      '& > *': {
        display: 'table'
      }
    },
    fabIcon: {
      width: '32px',
      height: '32px',
      fontSize: '32px'
    },
    fabLabel: {
      padding: '0 6px 0 4px',
      fontWeight: 500,
      fontSize: '1.0em'
    },
    fabExtended: {
      zIndex: theme && theme.zIndex.drawer,
      boxShadow: '0 1px 2px 0 rgba(60,64,67,0.302), 0 1px 3px 1px rgba(60,64,67,0.149)',
      backgroundColor: '#fff',
      textTransform: 'none',
      // position: 'absolute',
      // bottom: 'auto',
      // right: 'auto',
      // top: '14px',
      // left: '12px',
      '&:hover': {
        boxShadow: '0 1px 3px 0 rgba(60,64,67,0.302), 0 4px 8px 3px rgba(60,64,67,0.149)',
        backgroundColor: '#fff'
      }
    },
    columnTitle: {
      marginBottom: theme.spacing(2)
    },
    ReplicateDates: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    InitReplicateDate: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    EndReplicateDate: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    accordionColumn: { flexBasis: '33.33%', },
    accordionHeading: { fontSize: theme.typography.pxToRem(15), },
    accordionDetails: { alignItems: 'center' }
  });